import { useState } from 'react';

import { RiveWrapped } from './RiveWrapped';
import { WrappedShareModal } from './WrappedShareModal';

import { WrappedData } from '@/api/wrapped';

interface WrappedContainerProps {
  data: WrappedData;
  onComplete: () => void;
  onShare: () => void;
}

export function WrappedContainer({ data, onComplete, onShare }: WrappedContainerProps) {
  const [showShareModal, setShowShareModal] = useState(false);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);

  // Handle share button click from Rive - open the verification modal
  const handleShare = (imageDataUrl?: string) => {
    if (imageDataUrl) {
      setCapturedImage(imageDataUrl);
    }
    setShowShareModal(true);
  };

  // Handle successful share verification
  const handleShareComplete = () => {
    onShare();
  };

  // Handle modal close
  const handleClose = () => {
    setShowShareModal(false);
    setCapturedImage(null);
  };

  return (
    <>
      {/* Rive Wrapped Animation */}
      <RiveWrapped
        data={data}
        onComplete={onComplete}
        onShare={handleShare}
      />

      {/* Share Verification Modal */}
      <WrappedShareModal
        open={showShareModal}
        onClose={handleClose}
        onShareComplete={handleShareComplete}
        data={data}
        capturedImage={capturedImage}
      />
    </>
  );
}
